import { createFileRoute } from '@tanstack/react-router';

import { PromptsPage } from '@/features/prompts';

export const Route = createFileRoute('/_authenticated/_withWorkspace/prompts')({
  component: PromptsPage,
});
